import React from 'react'
import { useFormatMessage } from '../../utils'
import styles from './styles.module.less'

export const AppFooter = () => {
  const formatMessage = useFormatMessage()

  return (
    <footer className={styles.footer}>
      <div className={styles.topSection}>
        Apex Clearing is registered with the SEC, a member of FINRA, a
        participant in SIPC and licensed in 53 states and territories. FINRA
        BrokerCheck reports for Apex Clearing are available at
        http://www.finra.org/brokercheck. Certain services referenced on this
        site are provided through partnerships between Apex Clearing Corporation
        and third-parties.
      </div>
      <div className={styles.footerCopyright}>
        <div className={`test-id-copyright ${styles.copyright}`}>
          <span>{`${formatMessage(
            'common.copyrightSymbol'
          )} ${new Date().getFullYear()} ${formatMessage(
            'common.apexClearingCorp'
          )}`}</span>
        </div>
        <div>
          {formatMessage('common.footer.member')} |{' '}
          <span className="app-version">
            ver {process.env.REACT_APP_VERSION}
          </span>
        </div>
      </div>
    </footer>
  )
}
